import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders dialog content into document.body instead of in place.
 *
 * A full-screen overlay must not live inside `.responsive-card`: on desktop that
 * element gets `transform: translateY(-2px)` on :hover (styles/index.css). A
 * transform makes the element the containing block for `position: fixed`
 * descendants, so the overlay collapses from the viewport to the card's box and
 * shifts up. The pointer then falls outside the card, :hover drops, the overlay
 * expands again, and the cycle repeats every frame — the screen flickers and the
 * dialog jitters up and down. Portalling to body sidesteps it entirely.
 */
const ModalPortal: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
};

export default ModalPortal;
